import { BookmarkRounded } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import moment from 'moment'
import { useNavigate } from 'react-router'
import useScreenWidth from '../../hooks/useScreenWidth'
import TooltipCards from '../TooltipCards'

const CardsFeed = ({ resources }: { resources: any }) => {
  const navigate = useNavigate()
  const isMobile = useScreenWidth(960)

  return (
    <Box display="flex" justifyContent="space-between" gap="22px" flexDirection={isMobile ? 'column' : 'row'}>
      {resources.map((resource: any) => (
        <Button
          key={resource.id}
          variant="outlined"
          onClick={() => navigate(`/biblioteca/${resource.id}`)}
          sx={{
            padding: '8px 16px',
            borderColor: 'primary.main',
            width: '100%'
          }}
        >
          <BookmarkRounded sx={[resource.visibility === 1 ? { fill: '#BFA75E' } : { fill: 'primary.main' }]} fontSize="large" />
          <Box pl={2} textAlign="left" minHeight={74} display="flex" flexDirection="column" justifyContent="center" width="100%">
            <TooltipCards titleCard={resource.title} classNameCustom="containerFeed" />
            <Typography variant="caption" color="textSecondary">{`${moment(resource.created_at).fromNow()}`}</Typography>
          </Box>
        </Button>
      ))}
    </Box>
  )
}

export default CardsFeed
